<template>
  <OurPage
    :back-route="backRoute"
    class="access-groups promotions-add"
    :title="$t('title.promotions.add')"
  >
    <PromotionsForm
      ref="promotionsForm"
      v-model="form"
      :upload-files="uploadFiles"
      :type="fileUploadType"
      @uploadFiles="handleUploadFiles"
      @deleteFiles="handleDeleteFile"
    />

    <PromotionProductsSection
      ref="productsSection"
      v-model="products"
      :not-found-skus.sync="notFoundSkus"
      :duplicate-skus.sync="duplicateSkus"
    />

    <template #footer-left>
      <OurButton class="button" :text="$t('button.save')" @click="onClickSaveButton" />
      <OurLink :route="backRoute">
        <OurButton class="button" :text="$t('button.back')" variant="secondary" />
      </OurLink>
    </template>
  </OurPage>
</template>

<script>
import apolloMixin from "@/mixins/apollo.mixin";
import PromotionsForm from "@/views/settings/promotions/add/_components/PromotionsForm.vue";
import PromotionProductsSection from "@/views/settings/promotions/add/_components/PromotionProductsSection.vue";
import {
  deleteFileMutation,
  uploadFilesMutation,
} from "@/views/settings/base-knowledge/chapter/add/gql/mutations";
import { createDealerIncentiveMutation } from "@/views/settings/promotions/add/gql/mutations";
import { addDealerIncentiveProductsByIdsMutation } from "@/views/settings/promotions/add/gql/products";
import { DEFAULT_MEASUREMENT_UNIT } from "@/views/settings/promotions/add/constants";

export default {
  name: "PromotionsAdd",

  components: {
    PromotionsForm,
    PromotionProductsSection,
  },

  mixins: [apolloMixin],

  data() {
    return {
      backRoute: {
        name: "Promotions",
        title: this.$t("title.promotions._"),
      },
      form: {
        name: "",
        description: "",
        startsAt: null,
        endsAt: null,
        measurementUnit: DEFAULT_MEASUREMENT_UNIT,
        targetValue: "",
        reward: "",
        color: "#3B82F6",
        typeId: "",
        files: { sync: [] },
      },
      products: [],
      notFoundSkus: [],
      duplicateSkus: [],
      uploadFiles: [],
      fileUploadType: "",
    };
  },

  methods: {
    async handleUploadFiles({ selectedFiles, type }) {
      const { uploadFiles: files } = await this.$post(
        uploadFilesMutation,
        { files: selectedFiles, collection: type },
        { withLoader: false, withNotify: false }
      );

      this.uploadFiles = files || [];
      this.fileUploadType = type;
    },

    async handleDeleteFile(id) {
      await this.$post(deleteFileMutation, { id }, { withLoader: false, withNotify: false });
    },

    applyProductMutationResult(result) {
      if (!result) {
        return;
      }

      if (result.notFoundArticles?.length) {
        this.notFoundSkus = [...new Set([...this.notFoundSkus, ...result.notFoundArticles])];
      }

      if (result.duplicateArticles?.length) {
        this.duplicateSkus = [...new Set([...this.duplicateSkus, ...result.duplicateArticles])];
      }
    },

    async onClickSaveButton() {
      if (!this.$refs.promotionsForm.emitForm()) {
        return;
      }

      if (!this.$refs.productsSection.validate()) {
        return;
      }

      const {
        name,
        description,
        startsAt,
        endsAt,
        measurementUnit,
        targetValue,
        reward,
        color,
        typeId,
        files,
      } = this.form;

      const { createDealerIncentive } = await this.$post(
        createDealerIncentiveMutation,
        {
          name: name.trim(),
          description,
          startsAt,
          endsAt,
          measurementUnit,
          targetValue,
          reward: reward.trim(),
          color,
          typeId,
          files,
        },
        { delaySuccessNotify: true }
      );

      if (!createDealerIncentive?.id) {
        return;
      }

      const productIds = this.$refs.productsSection.getProductIds();

      if (productIds.length) {
        const { addDealerIncentiveProductsByIds } = await this.$post(
          addDealerIncentiveProductsByIdsMutation,
          {
            dealerIncentiveId: createDealerIncentive.id,
            productIds,
          },
          { delaySuccessNotify: true, withNotify: false }
        );

        this.applyProductMutationResult(addDealerIncentiveProductsByIds);
      }

      await this.$router.push({ name: "Promotions" });
    },
  },
};
</script>
